import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  SelectionButtonComponent,
  UnselectionButtonComponent,
  WinCardComponent,
} from '@shared/components/challenges/elements';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CampaignPhase, SubType } from '@shared/constants';
import {
  ElementDirective,
  TooltipDirective,
  TooltipIfTruncatedDirective,
} from '@shared/directives';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant3Config } from '@shared/models';
import { AmountPipe } from '@shared/pipes';

import { StepBaseClass } from '../step.base.class';

import { ProgressSectionComponent } from './progress-section/progress-section.component';

@Component({
  selector: 'b2c-variant3',
  styleUrl: './variant3.component.scss',
  templateUrl: './variant3.component.html',
  imports: [
    AmountPipe,
    IconComponent,
    ElementDirective,
    NgOptimizedImage,
    WinCardComponent,
    TooltipDirective,
    ProgressSectionComponent,
    SelectionButtonComponent,
    UnselectionButtonComponent,
    TooltipIfTruncatedDirective,
  ],
})
export class Variant3Component extends StepBaseClass {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant3Config>();

  index = input<number>(0);
  loadBannerInPriority = input<boolean>(false);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  withShadow = input<boolean>(true);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  public SubType: typeof SubType = SubType;
}
